var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',{ref:"inputRef",class:_vm.className,attrs:{"type":"text","placeholder":_vm.inputPlaceholder}})}
var staticRenderFns = []

export { render, staticRenderFns }